module.exports = __webpack_public_path__ + "static/media/cutra.40df5dbc.png";